import React from "react";
import "./Toasts.scss";

export class Toast {
	text = "";
	type = "Default";
	life = 3;

	closing = false;
	timeout = null;

	constructor(text, type = "Default", life = 3) {
		this.text = text;
		this.type = type;
		this.life = life;
	}
}

export default class Toasts extends React.Component {
	state = { toasts: [] };

	componentDidMount() {
		Toasts.instance = this;

		Toasts.showToast = toast => {
			this.state.toasts.push(toast);

			this.forceUpdate();
		};
	}

	componentDidUpdate() {
		for (let toast of this.state.toasts) {
			if (toast.timeout != null)
				continue;

			toast.timeout =
				setTimeout(() => {
					toast.closing = true;

					this.forceUpdate();

					setTimeout(() => {
						this.state.toasts.splice(this.state.toasts.indexOf(toast), 1);

						this.forceUpdate();
					}, 500);
				}, toast.life * 1000);
		}
	}

	render() {
		return (
			<div className="ToastsContainer">
				{ [...this.state.toasts].map(toast => (
					<div key={this.state.toasts.indexOf(toast)} className={"Toast " + (toast.closing ? "Closing" : "Active") + " " + toast.type}>
						<span>
							{ toast.text }
						</span>
					</div>
				)) }
			</div>
		);
	}
}